module.exports = __webpack_public_path__ + "static/media/flagEngland.51d97342.svg";